/** Partita IVA in forma normalizzata: senza spazi, punti, trattini, barre né
 * prefisso "IT". Stessa regola del backend (`auth/partita_iva.py`), che la
 * salva e la confronta sempre così. */
export function normalizzaPartitaIva(v: string): string {
  return v.replace(/[\s.\-/]/g, '').toUpperCase().replace(/^IT/, '');
}

/** 11 cifre con cifra di controllo valida: le cifre in posizione pari (da 1)
 * si raddoppiano, togliendo 9 se superano 9; la somma deve finire per 0. */
export function partitaIvaValida(piva: string): boolean {
  if (!/^\d{11}$/.test(piva)) return false;
  let somma = 0;
  for (let i = 0; i < 11; i++) {
    let n = Number(piva[i]);
    if (i % 2 === 1) n = n > 4 ? n * 2 - 9 : n * 2;
    somma += n;
  }
  return somma % 10 === 0;
}
